module.exports = __webpack_public_path__ + "media/customizations/mayfairtxlife/logo-985d9c3193d38489ad8d8e89536bb3b3.png";